import {
    server
} from "@/api";


export const initial = async () => {
    return await server().get('api/app/initial')
}

export const forms = {
    users: async (roles = []) => {
        return await server().get('api/app/form-data/users', { params: { roles } })
    },
    countries: async () => {
        return await server().get('api/app/form-data/countries')
    },
    categories: async (type = 'all') => {
        return await server().get('api/app/form-data/categories/' + type)
    },
    certificates: async (type = 'all') => {
        return await server().get('api/app/form-data/certificates/' + type)
    },

    multipleCategories: async (types = ['all']) => {
        return await server().get('api/app/form-data/multiple-categories', { params: { types } })
    },
}

export default {
    initial,
    forms
}